import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Calendar, MapPin, Trophy, Users, ArrowRight } from "lucide-react";
import { fileUrl } from "@/components/ImageUpload";
import { fmtDate, CURRENCY_SYMBOLS } from "@/lib/tournament";

export function TournamentCard({ t, i = 0 }) {
  const nav = useNavigate();
  const fee = Number(t.entry_fee || 0);
  const dates = [fmtDate(t.start_date), fmtDate(t.end_date)].filter(Boolean).join(" → ");
  const full = t.spots_left === 0;
  return (
    <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.06 }}
      className="rounded-3xl glow-border overflow-hidden bg-surface flex flex-col hover:-translate-y-1 transition-transform" data-testid={`upcoming-card-${t.tournament_id}`}>
      <div className="relative aspect-[16/7]" style={{ background: "var(--bg)" }}>
        {t.banner_url ? <img src={fileUrl(t.banner_url)} alt="" className="w-full h-full object-cover" />
          : <div className="w-full h-full flex items-center justify-center cyber-grid"><Trophy className="w-9 h-9 text-primary-c opacity-40" /></div>}
        <span className="absolute top-3 left-3 mono text-[10px] uppercase tracking-wider glass rounded-full px-2.5 py-1 font-bold" style={{ color: t.status === "live" ? "#ef4444" : "var(--primary)" }}>
          {t.status === "live" ? "● Live now" : "Registration open"}
        </span>
      </div>
      <div className="p-5 flex flex-col flex-1">
        <h3 className="font-display font-bold text-lg break-words" data-testid={`upcoming-name-${t.tournament_id}`}>{t.name}</h3>
        <div className="mt-2 space-y-1.5 text-sm" style={{ color: "var(--text-2)" }}>
          {dates && <div className="flex items-center gap-2"><Calendar className="w-4 h-4 text-primary-c shrink-0" />{dates}</div>}
          {t.venue && <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-primary-c shrink-0" /><span className="truncate">{t.venue}</span></div>}
        </div>
        <div className="flex flex-wrap gap-1.5 mt-3">
          {t.categories.slice(0, 3).map((c) => <span key={c} className="text-[11px] glass rounded-full px-2.5 py-1">{c}</span>)}
          {t.categories.length > 3 && <span className="text-[11px] glass rounded-full px-2.5 py-1">+{t.categories.length - 3} more</span>}
        </div>
        <div className="mt-auto pt-5 flex items-center justify-between gap-3">
          <div>
            <div className="font-display font-black text-xl" data-testid={`upcoming-fee-${t.tournament_id}`}>{fee > 0 ? `${CURRENCY_SYMBOLS[t.currency] || "₱"}${fee.toLocaleString()}` : "Free"}</div>
            {t.spots_left != null && <div className="text-xs flex items-center gap-1" style={{ color: full ? "#eab308" : "var(--text-2)" }} data-testid={`upcoming-spots-${t.tournament_id}`}>
              <Users className="w-3.5 h-3.5" />{full ? "Full · waitlist open" : `${t.spots_left} spot${t.spots_left === 1 ? "" : "s"} left`}</div>}
          </div>
          <button data-testid={`upcoming-register-${t.tournament_id}`} onClick={() => nav(`/t/${t.tournament_id}`)}
            className="btn-glow rounded-full px-5 py-2.5 text-sm font-bold flex items-center gap-1.5 shrink-0">
            {full ? "Join waitlist" : "Register"} <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </motion.div>
  );
}
